// import { Container, Row, Col } from "react-bootstrap"
// import "../components/styles/WhyChooseUs.css"
// import rightImage1 from '../assets/SSP/homeBanner1.jpeg'
// import rightImage2 from '../assets/SSP/homeBanner2.jpeg'
// import rightImage3 from '../assets/SSP/homeBanner3.jpeg'
// function WhyChooseUs() {
//   const reasons = [
//     {
//       icon: "bi bi-award",
//       title: "Extensive Experience",
//       description:
//         "With over 30 years of expertise, we have successfully served more than 5,000 clients across India, ensuring reliable and impactful IT solutions.",
//     },
//     {
//       icon: "bi bi-tools",
//       title: "Comprehensive Services",
//       description:
//         "We offer a wide range of services, from IT hardware and software licensing to managed services, telecom, and cloud solutions, providing complete end-to-end IT support.",
//     },
//     {
//       icon: "bi bi-bullseye",
//       title: "Tailored Solutions",
//       description:
//         "Our solutions are crafted to meet your unique business needs, delivering cost-effective, high-tech innovations that drive growth and efficiency.",
//     },
//   ]

//   return (
//     <section className="why-choose-section">
//       <Container>
//         <Row>
//           <Col lg={6}>
//             <div className="why-choose-image">
//               <img src={rightImage} alt="IT Dashboard" className="img-fluid" />
//             </div>
//           </Col>
//           <Col lg={6}>
//             <div className="why-choose-content">
//               <h2 className="section-title">Why Choose SunShiny.</h2>
//               <p className="section-description">
//                 At Sukh Info Solutions, we combine decades of experience with cutting-edge technology to deliver
//                 tailored IT solutions that drive business growth and security. Here's why we stand out:
//               </p>

//               {reasons.map((reason, index) => (
//                 <div className="reason-item" key={index}>
//                   <div className="reason-icon">
//                     <i className={reason.icon}></i>
//                   </div>
//                   <div className="reason-content">
//                     <h4>{reason.title}</h4>
//                     <p>{reason.description}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </section>
//   )
// }

// export default WhyChooseUs

import { Container, Row, Col, Carousel } from "react-bootstrap";
import "../components/styles/WhyChooseUs.css";
import rightImage1 from '../assets/SSP/homeBanner1.jpeg';
import rightImage2 from '../assets/SSP/homeBanner2.jpeg';
import rightImage3 from '../assets/SSP/homeBanner3.jpeg';

function WhyChooseUs() {
  const reasons = [
    {
      icon: "bi bi-award",
      title: "Extensive Experience",
      description:
        "With over 30 years of expertise, we have successfully served more than 5,000 clients across India, ensuring reliable and impactful IT solutions.",
    },
    {
      icon: "bi bi-tools",
      title: "Comprehensive Services",
      description:
        "We offer a wide range of services, from IT hardware and software licensing to managed services, telecom, and cloud solutions, providing complete end-to-end IT support.",
    },
    {
      icon: "bi bi-bullseye",
      title: "Tailored Solutions",
      description:
        "Our solutions are crafted to meet your unique business needs, delivering cost-effective, high-tech innovations that drive growth and efficiency.",
    },
  ];

  return (
    <section className="why-choose-section">
      <Container>
        <Row className="align-items-center">
          {/* Left side: Image slider */}
          <Col lg={6}>
            <Carousel className="why-choose-carousel">
              <Carousel.Item>
                <img src={rightImage1} alt="IT Dashboard" className="img-fluid" />
              </Carousel.Item>
              <Carousel.Item>
                <img src={rightImage2} alt="IT Solutions" className="img-fluid" />
              </Carousel.Item>
              <Carousel.Item>
                <img src={rightImage3} alt="Business Growth" className="img-fluid" />
              </Carousel.Item>
            </Carousel>
          </Col>

          {/* Right side: Text content */}
          <Col lg={6}>
            <div className="why-choose-content">
              <h2 className="section-title">Why Choose SunShiny.</h2>
              <p className="section-description">
                At Sukh Info Solutions, we combine decades of experience with cutting-edge technology to deliver
                tailored IT solutions that drive business growth and security. Here's why we stand out:
              </p>

              {reasons.map((reason, index) => (
                <div className="reason-item" key={index}>
                  <div className="reason-icon">
                    <i className={reason.icon}></i>
                  </div>
                  <div className="reason-content">
                    <h4>{reason.title}</h4>
                    <p>{reason.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default WhyChooseUs;
